<template>
	<div class="main-container">
		<div class="vin-input-container">
			<table class="vin-table">
				<thead>
					<tr>
						<th></th>
						<th>شماره موبایل نیروی اجرایی</th>
						<th>کد مشتری</th>
						<th></th>
						<th class="delete" @click="deleteAll">حذف همه موارد</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in actionModel" :key="item.id" class="td-data">
						<td class="line">{{ index + 1 }}.</td>
						<td>
							<input type="text" v-model="item.promoter_phone_number" class="data-input" />
						</td>
						<td>
							<input type="text" v-model="item.outlet_code" class="data-input" />
						</td>
						<td>
							<button
								@click="openGuideModal"
								v-if="actionModel.length === index + 1"
								class="add-item"
							>
								<img src="../../assets/images/iconPack/guide.svg" />
							</button>
							<button @click="addItem" v-if="actionModel.length === index + 1" class="add-item">
								<img src="@/assets/images/iconPack/plus-green.svg" />
								افزودن
							</button>
						</td>
						<td class="delete" @click="deleteItem(item.id, index)">
							<!-- <span class="iconify delete-border" data-icon="fluent:delete-20-regular"></span> -->
							<img class="iconify delete-border" src="@/assets/images/iconPack/red-trash.svg" />
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="file-vin-container">
			<div class="title-file-text-container">
				<p>
					برای دریافت نمونه مشاهده و نمونه اپلود
					<span
						><a href="https://s3.ir-thr-at1.arvanstorage.ir/leadv2-bucket/Action_Plan_Import.xlsx" download="">اینجا</a>
					</span>
					کلیک کنید.
				</p>
			</div>
			<div class="upload-box">
				<input type="file" @change="senExcelFile" />
				<div class="icon">
					<!-- <span class="iconify" data-icon="ic:outline-file-upload"></span> -->
					<img class="iconify" src="@/assets/images/iconPack/upload.svg" />
				</div>
				<span class="upload-text">آپلود فایل</span>
				<p>فایل مورد نظر خود را در این محل بکشید و رها کنید</p>
			</div>
		</div>
		<b-modal size="lg" v-model="guideModal" hide-footer hide-header centered>
			<div class="p-4">
				<div class="row d-flex">
					<div class="col d-flex flex-column">
						<label for="html">استان:</label>
						<select @change="getCityOnChange" v-model="pickProvince" class="form-select inputs">
							<option v-for="province in provinceLists" :value="province.id" :key="province.id">
								{{ province.name }}
							</option>
						</select>
					</div>
					<div class="col d-flex flex-column">
						<label for="html">شهر:</label>
						<select v-model="pickCity" class="form-select inputs">
							<option v-for="city in cityLists" :value="city.city.id" :key="city.city.id">
								{{ city.city.name }}
							</option>
						</select>
					</div>
					<div class="col d-flex flex-column">
						<label for="html">نوع مشتری:</label>
						<select v-model="pickOtlet" class="form-select inputs">
							<option v-for="outlet in outletCat" :value="outlet.id" :key="outlet.id">
								<span>{{ outlet.verbose_name }}</span>
							</option>
						</select>
					</div>
				</div>
				<div class="mt-3 w-100 d-flex justify-content-end">
					<button :disabled="disabledSearch" @click="outletCodeResult" class="add-item ml-0">
						جستجو
					</button>
				</div>
			</div>
		</b-modal>
		<b-modal size="lg" scrollable v-model="outletCodeModal" hide-footer centered>
			<div class="w-100 d-flex justify-content-center" v-if="loading">
				<b-spinner  label="Spinning"></b-spinner>
			</div>
			<Tableview v-else :hover="true" :bordered="true" :showNoContent="showContnetFunc"
					:showNoData="showDataFunc">
				<template #TableTitle>
					<tr>
						<th>ردیف</th>
						<th>شهر</th>
						<th>نوع مشتری</th>
						<th>نام مشتری</th>
						<th>آدرس</th>
						<th>کد</th>
					</tr>
				</template>

				<template #TableBody>
					<tr v-for="(item, index) in outletList" :key="item.id">
						<td class="persian-number">
							{{ index + 1 }}
						</td>
						<td>{{ item.city.name }}</td>
						<td>
							<span v-if="item.category.name === 'ChainStore'">مشتری زنجیره ای</span>
							<span v-if="item.category.name === 'MultiBrand'">مولتی برند</span>
							<span v-if="item.category.name === 'BrandShop'">برند شاپ</span>
						</td>
						<td>{{ item.name }}</td>
						<td>{{ item.address }}</td>
						<td
							ref="mylink"
							v-b-tooltip.hover
							title="برای کپی کردن کد روی کد کلیک کنید."
							@click="copyText(item.code)"
							class="coppy-code"
						>
							{{ item.code }}
						</td>
					</tr>
				</template>
			</Tableview>
		</b-modal>
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';

export default {
	data() {
		return {
			guideModal: false,
			cityLists: [],
			provinceLists: [],
			pickProvince: '',
			pickCity: '',
			pickOtlet: '',
			outletCat: [],
			outletList: 0,
			outletCodeModal: false,
			message: '',
			loading:false,
			actionModel: [{ id: 1, promoter_phone_number: null }],
		};
	},
	components: {
		Tableview,
	},
	props: {
		fromParent: {
			type: Boolean,
			default: false,
		},
		vinParent: {
			type: Array,
		},
	},
	computed: {
		disabledSearch() {
			if (this.pickProvince === '' || this.pickProvince === null) {
				return true;
			} else {
				return false;
			}
		},
		showContnetFunc() {
            return this.outletList === 0
        },
        showDataFunc() {
            if (this.outletList.length !== undefined){
                return this.outletList.length === 0
            }
            return false
        },
	},
	methods: {
		addItem() {
			if (
				!this.actionModel[this.actionModel.length - 1].promoter_phone_number ||
				!this.actionModel[this.actionModel.length - 1].outlet_code
			) {
				this.$notify({
					group: 'tc',
					type: 'danger',
					text: 'تکمیل هر دو بخشِ شماره نیروی اجرایی و کد مشتری جهت ثبت برنامه الزامی است.',
				});
			} else {
				this.actionModel.push({
					id: this.actionModel.length + 1,
					promoter_phone_number: '',
					outlet_code: '',
				});
				this.$emit('sendPhoneNumber', this.actionModel);
			}
		},
		outletCodeResult() {
			this.outletCodeModal = !this.outletCodeModal;
			this.guideModal = !this.guideModal;
			this.loading = true;
			this.getOutletList();
		},
		openGuideModal() {
			this.guideModal = !this.guideModal;
			this.getCity();
			this.getProvince();
			this.getOutletCat();
		},
		async getProvince() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_PROVINCE_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.provinceLists = res.data;
			}
		},
		async getOutletList() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_OUTLET_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId + '&city=' + this.pickCity + '&city__province=' + this.pickProvince + '&category=' + this.pickOtlet,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.loading = false;
				this.outletList = res.data;
			}
		},
		async copyText(code) {
			try {
				await navigator.clipboard.writeText(code);
				this.$notify({
					group: 'tc',
					type: 'success',
					text: ' کد با موفقیت کپی شد!',
				});
			} catch (err) {
				(err);
			}
		},
		async getCity() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_CITY_LIST +
					'?city__province=' +
					this.selectedkCity +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.cityLists = res.data;
			}
		},
		async getOutletCat() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.OUTLET_CAT + '?p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.outletCat = res.data;
			}
		},
		getCityOnChange() {
			this.selectedkCity = this.pickProvince;
			this.getCity();
		},
		deleteItem(id, index) {
			if (index === 0 && this.actionModel.length === 1) {
				return false;
			} else {
				this.actionModel.splice(index, 1);
			}
		},
		deleteAll() {
			this.actionModel = [];
			this.actionModel.push({ id: 1, promoter_phone_number: null });
			this.$emit('sendPhoneNumber', this.actionModel);
		},
		async senExcelFile(e) {
			let fd = new FormData();
			fd.append('file', e.target.files[0]);
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.POST.UPLOAD_EXCEL_FILE +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				'',
				fd,
			);
			if (res.status === 200) {
				this.actionModel = [];
				('ssss', res.data);
				res.data.data.forEach((item, index) => {
					this.actionModel.push({
						id: index,
						promoter_phone_number: item.promoter_phone_number,
						outlet_code: item.outlet_code,
					});
					this.$emit('sendPhoneNumber', this.actionModel);
				});
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.vin-input-container {
	width: 100%;
	margin-bottom: 20px;
	.vin-table {
		width: 100%;
		text-align: right;
		tr {
			width: 100%;
			height: 60px;
			.line {
				border-right: 3px solid #2d8b8b;
				font-family: 'IRANYekanfa' !important;
				padding: 10px;
			}
			th {
				width: 25%;
				text-align: right;
				&:first-child {
					width: 5%;
				}
			}
		}
	}
	.td-data {
		margin-bottom: 20px;
	}
}
.delete {
	color: #f54545;
	cursor: pointer;
	text-align: center !important;
	.iconify {
		font-size: 50px;
	}
	.delete-border {
		border: 1px solid #f54545;
		border-radius: 8px;
		padding: 10px;
		width: 42px;
	}
}
.data-input {
	width: 240px;
	height: 48px;
	border: 1px solid #c4c4c4;
	border-radius: 8px;
	margin-left: 16px;
	box-sizing: border-box;
	text-indent: 10px;
	font-family: 'IRANYekanfa' !important;
}
.add-item {
	background: none;
	padding: 8px;
	border: 1px solid #2d8b8b;
	border-radius: 8px;
	color: #2d8b8b;
	margin-left: 8px;
	&:disabled {
		background: #f1f1f1;
		color: #535656;
		border-radius: 8px;
		border: none;
		padding: 8px;
	}
}
.inputs {
	width: 100%;
	height: 38px;
	border: 1px solid #c4c4c4;

	border-radius: 8px;
}
.title-file-text-container {
	width: 100%;
	display: flex;
	text-align: right;
	margin-top: 100px;
	p,
	span {
		font-size: 14px;
	}
	span {
		color: #2d8b8b;
		cursor: pointer;
	}
}
.upload-box {
	width: 100%;
	height: 200px;
	background: #f8f8f8;
	margin-top: 24px;
	border-radius: 8px;
	border: 2px dashed #2d8b8b;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	position: relative;
	.upload-text {
		color: #2d8b8b;
	}
	input {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		opacity: 0;
	}
	.icon {
		margin-bottom: 20px;
		.iconify {
			font-size: 40px;
			color: #404041cc;
		}
	}
	p {
		color: #404041;
	}
}
.coppy-code {
	&:hover {
		cursor: pointer;
	}
}
// .counter-container {
// 	width: 100px;
// 	height: 50px;
// 	border: 1px solid #c4c4c4;
// 	position: relative;
// 	display: flex;
// 	// margin: 0 auto;
// 	.input-container {
// 		width: 100%;
// 		input {
// 			width: 100%;
// 			height: 100%;
// 			border: none;
// 			text-indent: 10px;
// 			&:focus {
// 				outline: none;
// 			}
// 		}
// 		input[type='number']::-webkit-inner-spin-button,
// 		input[type='number']::-webkit-outer-spin-button {
// 			-webkit-appearance: none;
// 			margin: 0;
// 		}
// 	}
// 	.arrow-container {
// 		width: 50px;
// 		flex: 1;
// 		display: flex;
// 		flex-direction: column;

// 		.arrow {
// 			width: 30px;
// 			height: 100%;
// 			border-right: 1px solid #c4c4c4;
// 			cursor: pointer;
// 			display: flex;
// 			justify-content: center;
// 			align-items: center;
// 		}
// 		.up {
// 			border-bottom: 1px solid #c4c4c4;
// 		}
// 	}
// }
</style>
